import {
    getJsonAsync,
    postJsonAsync
  } from 'shared/actions';

import {toastr} from 'react-redux-toastr';
import {initialize, reset} from 'redux-form';

import {
  displayEditAccountModalVisibility,
  displayFinanceAccountsList    
} from './actionTypes';

export const loadFinancialAccounts = () => (dispatch) => {
    dispatch(getJsonAsync(`finance/getaccounts`))
        .then(data => {
        dispatch(displayFinanceAccountsList(data));
        })
        .catch(() => { }); 
};

export const handleDeactivateAccount = data => (dispatch) => {
  
  dispatch(postJsonAsync(`finance/deactivateaccount`, { accountId: data }))
    .then(response => {
      
      if(response != null && response.isSuccess == true)
      {
        dispatch(loadFinancialAccounts());
      }
      else{
        toastr.error('Error', 'An error occured while deactivating the account.');
      }
    })
    .catch(() => {
      toastr.error('Error','An error occured while deactivating the account.');
    });
};

export const handleAccountNameEditClick = (accountId) => (dispatch, getState) => {
  const accountsList = getState().finance.accounts.accountsList;
  const account = accountsList.accounts.find(x => x.id === accountId);
  const accountName = account.name;
  const data = {
    accountId: accountId,
    accountName: accountName
  };

  dispatch(displayEditAccountModalVisibility(true));
  dispatch(initialize('editAccountForm', data));
  setTimeout(() => {
    // focus field after animatation finished (~800ms) by directly accessing the dom
    document.querySelectorAll('.modal-dialog #editAccountForm [name=accountName]')[0].focus();
  }, 800);
};

export const handleEditAccountModalCancel = () => dispatch => {
  dispatch(displayEditAccountModalVisibility(false));
  dispatch(reset('editAccountForm'));
};

export const handleEditAccountModalSave = data => (dispatch) => new Promise((resolve, reject) => {
  dispatch(postJsonAsync(`finance/modifyaccount`, data))
  .then(() => {
    toastr.success('Saved!', 'Account successfully saved.');
    dispatch(displayEditAccountModalVisibility(false));
    dispatch(reset('editAccountForm'));
    dispatch(loadFinancialAccounts());
    resolve();
  })
  .catch(error => reject(error));
});

export const completeCreateAccount = () => (dispatch) => new Promise((resolve, reject) => {   

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const request = { code, state };

  dispatch(postJsonAsync(`finance/createaccount`, request))
    .then(response => {
      
      if(response != null && response.isSuccess == true)
      {
        toastr.success('Account created successfully!');
        resolve();
      }
      else{
        toastr.error('Error Creating Account!', 'An error occured while creating the account.');
        reject();
      }
    }).catch(error => reject(error));
});


// WEBPACK FOOTER //
// ./src/features/finance/accounts/actions.js